/**
 * The purpose of this is to disable angular from detecting
 * any changes for the following events below. Because
 * it's being disabled, if these need to be triggered, they will
 * need to be triggered manually.
 * These events happen so often, and trigger change detection on so many table rows, that it makes scrolling very slow and jittery.
 * With change detection off, scrolling is much more smooth and natural.
 */

interface Window {
  __zone_symbol__BLACK_LISTED_EVENTS: string[]
}

window.__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove', 'wheel'] // disable patch specified eventNames
